import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { VoucherForm } from '@app/components/voucher/Voucher';
const VoucherPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('Voucher')}</PageTitle>
      <VoucherForm />
    </>
  );
};
export default VoucherPage;
